import deepmerge from 'deepmerge';

import defaultPalette from '@/uptk/core/packages/style/color';

export { defaultPalette }

export const createColorPalette = (paletteOptions: any) => {
  const palette
      = typeof paletteOptions == 'function'
          ? paletteOptions(defaultPalette)
          : paletteOptions;
  return deepmerge(defaultPalette, palette, { clone: false });
};
